import { Layer, DomUtil } from 'leaflet';

export default class extends Layer {
  #horizontalLine = DomUtil.create('div');
  #verticalLine = DomUtil.create('div');

  /**
   * @param {L.Map} map Leaflet Map instance
   */
  onAdd(map) {
    this.map = map;
    let pane = map.getPane(this.options.pane);

    pane.appendChild(this.#horizontalLine);
    pane.appendChild(this.#verticalLine);

    this.#horizontalLine.style.borderTop = '1px solid rgba(255, 255, 255, 0.8)';
    this.#verticalLine.style.borderLeft = '1px solid rgba(255, 255, 255, 0.8)';

    this.#horizontalLine.style.height = '1px';
    this.#verticalLine.style.width = '1px';

    this.#update();

    map.on('zoomend viewreset move', this.#update, this);
  }

  /**
   * @param {L.Map} map Leaftlet Map instance
   */
  onRemove(map) {
    DomUtil.remove(this.#horizontalLine);
    DomUtil.remove(this.#verticalLine);
    map.off('zoomend viewreset move', this.#update, this);
  }

  #update() {
    let bounds = this.map.getBounds();

    let north = bounds.getNorth();
    let west = bounds.getWest();
    let center = bounds.getCenter()

    let size = this.map.getPixelBounds().getSize();

    this.map.latLngToLayerPoint([center.lat, west]).round();

    this.#horizontalLine.style.width = `${size.x}px`;
    DomUtil.setPosition(this.#horizontalLine, this.map.latLngToLayerPoint([center.lat, west]).round());

    this.#verticalLine.style.height = `${size.y}px`;
    DomUtil.setPosition(this.#verticalLine, this.map.latLngToLayerPoint([north, center.lng]).round());
  }
}
